import EventBusyIcon from '@mui/icons-material/EventBusy'
import NearbyErrorIcon from '@mui/icons-material/NearbyError'
import SyncProblemIcon from '@mui/icons-material/SyncProblem'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

export { LinkedProjectsLegend }

const LinkedProjectsLegend = () => {
  return (
    <Grid container spacing={1} sx={{ paddingLeft: 2, paddingRight: 2 }}>
      <Grid
        size={{ xs: 12 }}
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
      >
        <Box
          sx={{
            height: 24,
            width: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{ height: 20, width: 20, border: '2px dashed rgba(0,0,0,.4)' }}
          />
        </Box>
        <Typography>
          Aansluiting project(en) gekoppeld aan een hoofdleiding
        </Typography>
      </Grid>

      <Grid
        size={{ xs: 12 }}
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
      >
        <EventBusyIcon sx={{ opacity: 0.5 }} />
        <Typography>
          Werkvoorbereiding netbeheerder wordt later opgeleverd dan plandatum
          project
        </Typography>
      </Grid>

      <Grid
        size={{ xs: 12 }}
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
      >
        <NearbyErrorIcon sx={{ opacity: 0.5 }} />
        <Typography>
          Aansluiting project is eerder gepland dan de start van het
          Hoofdleiding project
        </Typography>
      </Grid>

      <Grid
        size={{ xs: 12 }}
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
      >
        <SyncProblemIcon sx={{ opacity: 0.5 }} />
        <Typography>
          Aansluiting projecten zijn gepland op verschillende datums
        </Typography>
      </Grid>
    </Grid>
  )
}
